import { PropsWithChildren } from 'react';

import FormNode from '../FormNode';
import { ControlledFieldContext, type ControlledFieldContextValue } from './ControlledFieldContext';
import ControlledFieldControl from './ControlledFieldControl';
import ControlledFieldErrorMessage from './ControlledFieldErrorMessage';
import ControlledFieldLabel from './ControlledFieldLabel';

type ControlledFieldProps<C extends React.ElementType> = PolymorphicComponentProp<
  C,
  PropsWithChildren<ControlledFieldContextValue>
>;

const ControlledField = <C extends React.ElementType = typeof FormNode>({
  as,
  ...props
}: ControlledFieldProps<C>) => {
  const Component = as || FormNode;

  return (
    <ControlledFieldContext.Provider value={props}>
      <Component {...props} />
    </ControlledFieldContext.Provider>
  );
};

ControlledField.Label = ControlledFieldLabel;
ControlledField.Control = ControlledFieldControl;
ControlledField.ErrorMessage = ControlledFieldErrorMessage;

export default ControlledField;
